import * as React from "react";
import type { SVGProps } from "react";
const SvgWallet02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.76 3.04H3.893c-.824 0-1.491.887-1.492 1.8-.001 1.2.668 2.387 1.492 2.387h15.574c1.178 0 2.133-.245 2.133.933V18.4a2.56 2.56 0 0 1-2.56 2.56H4.96A2.56 2.56 0 0 1 2.4 18.4V5.44m14.097 7.823-.017.017"
    />
  </svg>
);
export default SvgWallet02;
